

















































































import { api_post, api_get, http_withoutcookie } from '@/utils/http'
import { msgTip } from '@/utils/urlUtils'
import { Component, Vue, Prop, Provide, Watch, Emit } from 'vue-property-decorator'
import Modal from './../../enroll/Modal.vue'
import ImgCode from './../../enroll/ImgCode.vue'
import { AButton } from './../../../components'
import countBtn from './../../enroll/CountBtn.vue'

@Component({
  components: { Modal, ImgCode, AButton, countBtn }
})
export default class TestJeyoo extends Vue {
  public visible = false
  public loading = false
  public status = false
  public success = false
  public needPhone = false
  public needPhoneTest = false
  public request_error = ''
  public code = ''
  public imgCodeSrc = ''
  public code_error = ''
  public sms_code_error = ''
  public codePhone = ''
  public account = ''
  public address = '/search/api/auth/send-sms-code-3rd'
  public clean = ''

  @Prop() public show!: boolean

  public get resUse() {
    return {
      usage: '3rd-bind',
      phone: this.account,
      domain: 'zxxk',
      captcha: this.code
    }
  }
  public get bindAccount() {
    if (this.$store.state.bindAccounts && this.$store.state.bindAccounts.length > 0) {
      return (
        this.$store.state.bindAccounts.find((itm) => {
          return itm.domain === 'zxxk'
        }) || ''
      )
    }
    return ''
  }
  @Watch('show')
  onShowChange(val) {
    this.visible = val
  }
  @Watch('bindAccount', { immediate: true, deep: true })
  onAccountChange(val) {
    // console.log(val)
    this.account = val.account
  }
  @Watch('visible')
  onVisibleChange(val) {
    if (val) {
      this.clickLogin(false)
    } else {
      this.reset()
    }
  }
  @Emit()
  onClose(val) {
    return val
  }
  @Emit()
  logSuccess() {}

  public closeModal() {
    this.visible = false
    this.onClose(this.visible)
  }
  public mounted() {
    // this.getImageCode()
  }
  public reset() {
    this.loading = false
    this.success = false
    this.needPhone = false
    this.needPhoneTest = false
    this.request_error = ''
    this.code = ''
    this.imgCodeSrc = ''
    this.code_error = ''
    this.sms_code_error = ''
    this.codePhone = ''
    this.account = ''
  }
  /**
   * getImageCode
   */
  public async getImageCode() {
    //this.imgCodeSrc = this.imgCodeSrc + '?s=' + Math.random()
    let rdata = await http_withoutcookie('/search/api/auth/account/login', {
      domain: 'zxxk'
    })
    if (rdata.success) {
      this.imgCodeSrc = rdata.data.captcha_image_src + '?s=' + Math.random()
    } else {
      this.request_error = rdata.request_error || ''
      if (rdata.data.captcha_image_src) {
        this.imgCodeSrc = rdata.data.captcha_image_src + '?s=' + Math.random()
      }
      // switch (rdata.code) {
      //   case 5:
      //     this.imgCodeSrc = rdata.data.captcha_image_src + '?s=' + Math.random()
      //     break
      //   default:
      //     break
      // }
    }
  }
  public async clickLogin(val: boolean) {
    this.loading = true
    let rdata = await http_withoutcookie('/search/api/auth/account/login', {
      domain: 'zxxk',
      captcha: this.code || '',
      verifyCode: this.codePhone || ''
    })
    this.loading = false
    if (rdata.success) {
      this.success = true
      this.logSuccess()
      this.closeModal()
    } else {
      this.code_error = rdata.code_error || rdata.ode_error || ''
      switch (rdata.code) {
        case 1:
          if (rdata.data.captcha_image_src) {
            this.needPhone = true
            this.needPhoneTest = false
            this.imgCodeSrc = rdata.data.captcha_image_src + '?s=' + Math.random()
          }
          break
        case 5:
          this.imgCodeSrc = rdata.data.captcha_image_src + '?s=' + Math.random()
          this.sms_code_error = rdata.sms_code_error || ''
          this.needPhoneTest = true
          this.needPhone = true
          if (rdata.data.phone) {
            this.account = rdata.data.phone
          }
          break
        default:
          break
      }
    }
  }
  public removeFocus(e) {
    let id = e.target.id
    let targetParent = e.target.parentElement
    if (targetParent) {
      let classes = targetParent.classList
      classes.remove('nor-focus')
      if (id == 'account') {
        this.getImageCode()
      }
    }
  }
  public getFocus(e) {
    let targetParent = e.target.parentElement
    if (targetParent) {
      targetParent.classList.add('nor-focus')
    }
  }
  public resultHandler(msg) {
    if (msg) {
      this.code_error = msg
    } else {
      this.code_error = ''
    }
  }
}
